export function formatNumber(number: string | number) {
  if (typeof number === "string") {
    number = parseInt(number)
  }

  return number?.toLocaleString("sv-SE")
}
